var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('amplify-authenticator',{attrs:{"username-alias":"email"}},[(_vm.loaded)?_c('div',{attrs:{"id":"app"}},[_c('Menubar'),_c('div',{attrs:{"id":"main"}},[_c('router-view',{attrs:{"id":"main"}})],1),_c('Footer')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }